import { RuleConfigRow } from '../components/domain/RuleConfigRow';
import { TopStatusBar } from '../components/domain/TopStatusBar';
import { Card } from '../components/ui/Card';
import { useAccounts } from '../features/accounts/queries';
import { useMe } from '../features/auth/queries';
import { useUpdateRule } from '../features/rules/mutations';
import { useRules } from '../features/rules/queries';
import { useLatestSnapshot } from '../features/snapshots/queries';

export function Rules() {
  const me = useMe();
  const accounts = useAccounts();
  const rules = useRules();
  const updateRule = useUpdateRule();
  const snapshot = useLatestSnapshot(accounts.data?.[0]?.id ?? null);

  if (me.isLoading || rules.isLoading) {
    return <main className="p-6 text-text-muted">Loading rules...</main>;
  }

  if (me.isError || rules.isError || !me.data) {
    return <main className="p-6 text-danger">Could not load rules.</main>;
  }

  return (
    <main className="min-h-screen bg-bg text-text">
      <TopStatusBar currency={me.data.baseCurrency} snapshot={snapshot.data} />
      <div className="mx-auto max-w-7xl px-4 py-6">
        <Card
          header={
            <div>
              <h1 className="text-2xl font-semibold">Rules</h1>
              <p className="text-sm text-text-muted">Thresholds, severities, and enabled gates.</p>
            </div>
          }
        >
          <div>
            {rules.data?.map((rule) => (
              <RuleConfigRow
                key={rule.ruleKey}
                rule={rule}
                isSaving={updateRule.isPending}
                onSave={(body) => updateRule.mutate({ key: rule.ruleKey, body })}
              />
            ))}
          </div>
        </Card>
      </div>
    </main>
  );
}
